import { ColumnDef } from '@tanstack/react-table'
import { GetDynamicSectionDataResponse } from '@/modules/client-setting/type'
import { Badge } from '@/common/ui/badge'
import { Button } from '@/common/ui/button'
import { Pencil } from 'lucide-react'
import { Link } from 'react-router-dom'
import DeleteDynamicSectionModal from './components/DeleteDynamicSection'

export const columns: ColumnDef<GetDynamicSectionDataResponse>[] = [
	{
		accessorKey: 'name',
		header: 'ชื่อ',
	},
	{
		accessorKey: 'status',
		header: 'ประเภท',
		cell: ({ row }) => {
			const typeMap: Record<string, string> = {
				GAME_LIST: 'รายการเกม',
				LEADERBOARD: 'Leaderboard',
				LOTTO_ANNOUNCEMENT: 'รายการล็อตโต้',
				GAME_SUGGESTION: 'แนะนำเกม',
			}
			return (
				<Badge
					variant={row.original.type === 'GAME_LIST' ? 'default' : 'default'}
				>
					{typeMap[row.original.type] || row.original.type}
				</Badge>
			)
		},
	},
	{
		accessorKey: 'id',
		header: 'แก้ไข',
		cell: ({ row }) => (
			<Link to={`/operator/dynamic-section/${row.original.id}`}>
				<Button variant="ghost" size="icon">
					<Pencil className="h-4 w-4" />
				</Button>
			</Link>
		),
	},
	{
		accessorKey: 'delete',
		header: 'ลบ',
		cell: ({ row }) => <DeleteDynamicSectionModal id={row.original.id} />,
	},
	{
		accessorKey: 'createdAt',
		header: 'วันที่สร้าง',
		cell: ({ row }) => new Date(row.original.createdAt).toLocaleString(),
	},
	{
		accessorKey: 'updatedAt',
		header: 'วันที่แก้ไข',
		cell: ({ row }) =>
			row.original.updatedAt
				? new Date(row.original.updatedAt).toLocaleString()
				: '-',
	},
]
